/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/components/influencer-makeover-carousel.js":
/*!***********************************************************!*\
  !*** ./src/js/components/influencer-makeover-carousel.js ***!
  \***********************************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MakeoverTabs = /*#__PURE__*/function () {
  function MakeoverTabs() {
    _classCallCheck(this, MakeoverTabs);
    this.init();
  }
  return _createClass(MakeoverTabs, [{
    key: "init",
    value: function init() {
      this.initTabs();
      this.initCarousels();
    }
  }, {
    key: "initCarousels",
    value: function initCarousels() {
      // Initialize both tab carousels and regular carousel
      this.initTabCarousels();
      this.initRegularCarousel();
    }
  }, {
    key: "initTabCarousels",
    value: function initTabCarousels() {
      var _this = this;
      var tabPanels = document.querySelectorAll('.makeover-tabs__panel');
      tabPanels.forEach(function (panel) {
        _this.initSingleCarousel(panel);
      });
    }
  }, {
    key: "initRegularCarousel",
    value: function initRegularCarousel() {
      // Handle the regular carousel outside tabs
      var regularCarousel = document.querySelector('.makeover-carousel__grid:not(.has-tabs)');
      if (regularCarousel) {
        this.initSingleCarousel(regularCarousel);
      }
    }
  }, {
    key: "initSingleCarousel",
    value: function initSingleCarousel(container) {
      // Get preview and thumbnail containers
      var previewContainer = container.querySelector('.makeover-carousel__preview');
      var thumbnailContainer = container.querySelector('.makeover-carousel__thumbnail');
      if (!previewContainer || !thumbnailContainer) return;

      // Get all images within their respective containers
      var previewImages = Array.from(previewContainer.querySelectorAll('.preview-image'));
      var thumbnails = Array.from(thumbnailContainer.querySelectorAll('.thumbnail-image'));
      var prevButton = container.querySelector('.nav-button--prev');
      var nextButton = container.querySelector('.nav-button--next');
      if (!previewImages.length || !thumbnails.length) return;
      var currentIndex = 0;
      var updateCarousel = function updateCarousel(index) {
        // Remove active class from all items
        previewImages.forEach(function (preview) {
          return preview.classList.remove('active');
        });
        thumbnails.forEach(function (thumb) {
          return thumb.classList.remove('active');
        });

        // Add active class to current preview image
        previewImages[index].classList.add('active');

        // Add active class to next thumbnail (or first if at end)
        var nextIndex = (index + 1) % thumbnails.length;
        thumbnails[nextIndex].classList.add('active');
        currentIndex = index;
      };

      // Previous button click
      prevButton === null || prevButton === void 0 || prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var newIndex = currentIndex === 0 ? previewImages.length - 1 : currentIndex - 1;
        updateCarousel(newIndex);
      });

      // Next button click
      nextButton === null || nextButton === void 0 || nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var newIndex = currentIndex === previewImages.length - 1 ? 0 : currentIndex + 1;
        updateCarousel(newIndex);
      });

      // Add click handlers to thumbnails
      thumbnails.forEach(function (thumbnail, index) {
        thumbnail.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          // When clicking a thumbnail, show the previous image in the preview
          var prevIndex = index === 0 ? previewImages.length - 1 : index - 1;
          updateCarousel(prevIndex);
        });
      });

      // Initialize first slide
      updateCarousel(0);
    }
  }, {
    key: "initTabs",
    value: function initTabs() {
      var tabButtons = document.querySelectorAll('.tab-button[data-tab]');
      var tabPanels = document.querySelectorAll('.makeover-tabs__panel');

      // Show first panel by default
      if (tabPanels.length > 0) {
        tabPanels[0].classList.remove('makeover-tabs__panel--hidden');
      }
      tabButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var target = button.dataset.tab;

          // Remove active class from all tab buttons
          tabButtons.forEach(function (btn) {
            btn.classList.remove('tab-button--active');
          });

          // Add active class to clicked tab button
          button.classList.add('tab-button--active');

          // Hide all panels
          tabPanels.forEach(function (panel) {
            panel.classList.add('makeover-tabs__panel--hidden');
          });

          // Show target panel
          var activePanel = document.querySelector("[data-content=\"".concat(target, "\"]"));
          if (activePanel) {
            activePanel.classList.remove('makeover-tabs__panel--hidden');
          }
        });
      });

      // Initialize first tab if it has data-active="true"
      var defaultTab = document.querySelector('[data-tab][data-active="true"]');
      if (defaultTab) {
        defaultTab.click();
      }
    }
  }]);
}(); // Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', function () {
  new MakeoverTabs();
});

/***/ }),

/***/ "./src/scss/sections/influencer-makeover-carousel.scss":
/*!*************************************************************!*\
  !*** ./src/scss/sections/influencer-makeover-carousel.scss ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/influencer-makeover-carousel": 0,
/******/ 			"assets/influencer-makeover-carousel": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkresidence_supply"] = self["webpackChunkresidence_supply"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/influencer-makeover-carousel"], () => (__webpack_require__("./src/js/components/influencer-makeover-carousel.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/influencer-makeover-carousel"], () => (__webpack_require__("./src/scss/sections/influencer-makeover-carousel.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;